var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F0F2F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.75 14.75H13.75C13.5511 14.75 13.3603 14.671 13.2197 14.5303C13.079 14.3897 13 14.1989 13 14C13 13.8011 13.079 13.6103 13.2197 13.4697C13.3603 13.329 13.5511 13.25 13.75 13.25H26.5C26.6989 13.25 26.8897 13.171 27.0303 13.0303C27.171 12.8897 27.25 12.6989 27.25 12.5C27.25 12.3011 27.171 12.1103 27.0303 11.9697C26.8897 11.829 26.6989 11.75 26.5 11.75H13.75C13.1533 11.75 12.581 11.9871 12.159 12.409C11.7371 12.831 11.5 13.4033 11.5 14V26C11.5 26.5967 11.7371 27.169 12.159 27.591C12.581 28.0129 13.1533 28.25 13.75 28.25H28.75C29.1478 28.25 29.5294 28.092 29.8107 27.8107C30.092 27.5294 30.25 27.1478 30.25 26.75V16.25C30.25 15.8522 30.092 15.4706 29.8107 15.1893C29.5294 14.908 29.1478 14.75 28.75 14.75ZM28.75 26.75H13.75C13.5511 26.75 13.3603 26.671 13.2197 26.5303C13.079 26.3897 13 26.1989 13 26V16.1216C13.2408 16.2069 13.4945 16.2504 13.75 16.25H28.75V26.75ZM24.25 21.125C24.25 20.9025 24.316 20.685 24.4396 20.5C24.5632 20.315 24.7389 20.1708 24.9445 20.0856C25.15 20.0005 25.3762 19.9782 25.5945 20.0216C25.8127 20.065 26.0132 20.1722 26.1705 20.3295C26.3278 20.4868 26.435 20.6873 26.4784 20.9055C26.5218 21.1238 26.4995 21.35 26.4144 21.5555C26.3292 21.7611 26.185 21.9368 26 22.0604C25.815 22.184 25.5975 22.25 25.375 22.25C25.0766 22.25 24.7905 22.1315 24.5795 21.9205C24.3685 21.7095 24.25 21.4234 24.25 21.125Z",
    fill: "#A0A0A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardWallet);
export default __webpack_public_path__ + "static/media/card_wallet.7615cf52e1502c954afb4e531523e608.svg";
export { ForwardRef as ReactComponent };